// import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Typography } from '@mui/material';
// import React from 'react'

// const OrderItemChefAssign = ({assignChefOpen, setAssignChefOpen, assignChefData, assignChefSelections, setAssignChefSelections, pendingStatus, changeStatusApi, refetch, setAssignChefData, setPendingStatus}) => {
//     return (
//         <Dialog open={assignChefOpen} onClose={() => setAssignChefOpen(false)} maxWidth="sm" fullWidth>
//             <DialogTitle>Assign Chefs</DialogTitle>
//             <DialogContent>
//                 {assignChefData?.items?.map(item => (
//                     <Box key={item.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//                         <Typography>{item.name}</Typography>
//                         <Select
//                             value={assignChefSelections[item.id]}
//                             onChange={(e) =>
//                                 setAssignChefSelections(prev => ({ ...prev, [item.id]: e.target.value }))
//                             }
//                         >
//                             {item.stationData.chefs.map(chef => (
//                                 <MenuItem key={chef.id} value={chef.id}>{chef.name}</MenuItem>
//                             ))}
//                         </Select>
//                     </Box>
//                 ))}
//             </DialogContent>
//             <DialogActions>
//                 <Button onClick={() => setAssignChefOpen(false)}>Cancel</Button>
//                 <Button
//                     variant="contained"
//                     onClick={async () => {
//                         try {
//                             const payload = {
//                                 order_id: assignChefData.orderId,
//                                 status: pendingStatus,
//                                 items: Object.entries(assignChefSelections).map(([orderItemId, chefId]) => ({
//                                     order_item_id: orderItemId,
//                                     chef_id: chefId
//                                 }))
//                             };
//                             console.log("Payload for assigning chefs:", payload);
//                             // await changeStatusApi({ id: assignChefData.orderId, body: payload });
//                         } catch (err) {
//                             console.log("Error assigning chefs:", err);
//                         } finally {
//                             setAssignChefOpen(false);
//                             setAssignChefData(null);
//                             setAssignChefSelections({});
//                             setPendingStatus(null);
//                             refetch();
//                         }
//                     }}
//                 >
//                     Confirm
//                 </Button>
//             </DialogActions>
//         </Dialog>
//     )
// }

// export default OrderItemChefAssign


import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  Select,
  MenuItem
} from '@mui/material';
import CustomTypography from 'components/Fileds/CustomTypography';
import CustomSelect from 'components/Fileds/CustomSelect';
import CustomButton from 'components/Fileds/CustomButton';

const OrderItemChefAssign = ({
  open,
  onClose,
  orderItems = [],
  selections = {},
  onChangeChef,
  onSubmit,
  loading = false
}) => {
  return (
    // <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className="generic-dialog-container" 
        PaperProps={{ sx: { borderRadius: '20px', padding: '5px', color: 'black' } }}
      >
      <DialogTitle sx={{ fontWeight: 600 }}>Assign Chef to Items</DialogTitle>
      <DialogContent dividers>
        {orderItems?.map((item) => (
          <Box
            key={item.menu_item_id}
            className='d-flex align-items-center justify-content-between'
            sx={{
              py: 1.5,
              borderBottom: '1px solid #eee',
            }}
          >
            <Box>
              <Typography fontWeight={600}>{item.menu_item_name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {item.stationData?.name || 'No station'}
              </Typography>
            </Box>
            {/* <Select
              size="small"
              value={selections[item.menu_item_id] || ''}
              onChange={(e) => onChangeChef(item.menu_item_id, e.target.value)}
              sx={{ minWidth: 150 }}
            >
              {item?.stationData?.chefs?.map((chef) => (
                <MenuItem key={chef.id} value={chef.id}>
                  {chef.full_name || chef.username}
                </MenuItem>
              ))}
            </Select> */}
            <CustomSelect
              name={`chef-${item.menu_item_id}`}
              value={selections[item.menu_item_id] || ''}
              onChange={(e) => onChangeChef(item.menu_item_id, e.target.value)}
              placeholder="Select Chef"
              formWidth={150} // same as sx={{ minWidth: 150 }}
              options={
                item?.stationData?.chefs?.map((chef) => ({
                  value: chef.id,
                  label: chef.full_name || chef.username,
                })) || []
              }
            />
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={{mt: 0.5, gap:1}}>
        {/* <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button> */}

        <CustomButton
          onClick={onClose}
          disabled={loading}
          sx={{
            backgroundColor:'transparent',
            color:'black',
            borderRadius: "10px",
            width:'90px',
            py:2,
            height:'40px'
          }}
          variant="outlined"
        >
          Close
        </CustomButton>

        <CustomButton
             onClick={onSubmit}
            disabled={loading}
            sx={{ borderRadius: "10px", width: "120px", py: 2, height: '40px' }}
        >
            {loading ? 'Saving...' : 'Confirm'}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default OrderItemChefAssign;

